<template>
    <div>
        <div class="tableSelect" ref="tableSelect">
            <el-form :inline="true" label-position="left">
                <el-form-item label="日期：">
                    <el-date-picker 
                        @change="getData"
                        format="YYYY-MM"
                        value-format="YYYYMM"
                        v-model="formInline.month"
                        type="month"
                        placeholder="选择月">
                    </el-date-picker>
                </el-form-item>
            </el-form>
        </div>
        <div class="table">
            <el-table :height="'calc('+(tableHeight)+'px)'" stripe :data="tableData" ref="tableref" v-loading="loadingPage" style="width: 100%">
                <el-table-column type="index" width="60" align="center" label="序号">
                    <template #default="scope">
                        <span v-text="getIndex(scope.$index)"></span>
                    </template>
                </el-table-column>
                <el-table-column width="150" prop="payer_id" label="PayerId"></el-table-column>
                <el-table-column prop="filepath" label="文件路径"></el-table-column>
                <el-table-column prop="error" label="错误信息"></el-table-column>
                <el-table-column width="180" prop="uptime" label="下载时间"></el-table-column>
            </el-table>
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        </div>
    </div>
</template>
<script>
    import Pagination from "@/components/Pagination";
    import {getDownloadLog} from '@/api/api'
    import {getTableHeight} from "@/utils/util";
    export default {
        components:{
            Pagination
        },
        name:'logList',
        data() {
            return {
                loadingPage:false,
                tableHeight:500,
                formInline:{
                    month:'',
                    page: 1,
                    limit: 20,
                },
                tableData:[],
                pageparm: {
                    page: 1,
                    limit: 20,
                    total: 0
                },
            }
        },

        methods:{
            //获取列表
            getData() {
                this.loadingPage = true
                getDownloadLog(this.formInline).then(res => {
                    this.loadingPage = false
                    if(res.code ==2000) {
                        this.tableData = res.data.data
                        this.pageparm.page = res.data.page;
                        this.pageparm.limit = res.data.limit;
                        this.pageparm.total = res.data.total;
                    }else{
                        this.$message.error(res.msg)
                    }
                })
            },
            // 表格序列号
            getIndex($index) {
                // (当前页 - 1) * 当前显示数据条数 + 当前行数据的索引 + 1
                return (this.pageparm.page-1)*this.pageparm.limit + $index +1
            },
            callFather(parm) {
                this.formInline.page = parm.page
                this.formInline.limit = parm.limit
                this.getData()
            },
            // 计算搜索栏的高度
            listenResize() {
				this.$nextTick(() => {
				    this.getTheTableHeight()
				})
			},
            getTheTableHeight(){
                let tabSelectHeight = this.$refs.tableSelect?this.$refs.tableSelect.offsetHeight:0
                this.tableHeight =  getTableHeight(tabSelectHeight)
            }
        },
        created() {
            let date = new Date();
            //获取当前年份的后一年
            let endY =date.getFullYear();
            //获取当前月
            let endM = (date.getMonth()+1 < 10 ? '0' + (date.getMonth()+1 ) : date.getMonth()+1);
            this.formInline.month=endY+endM;
            this.getData();
        },
        mounted() {
            // 监听页面宽度变化搜索框的高度
            window.addEventListener('resize', this.listenResize);
            this.$nextTick(() => {
              this.getTheTableHeight()
            })
        },

        unmounted() {
             // 页面销毁，去掉监听事件
			window.removeEventListener("resize", this.listenResize);
        },
    }
</script>